import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useQuery = (): [
  URLSearchParams,
  (key: string, value: string | null) => void,
] => {
  const { pathname, search } = useLocation();
  const [query, setQuery] = useState<URLSearchParams>(
    new URLSearchParams(search),
  );

  useEffect(() => {
    setQuery(new URLSearchParams(search));
  }, [search]);

  const updateQuery = useCallback(
    (key: string, value: string | null) => {
      const newQuery = new URLSearchParams(search);
      if (value == null) newQuery.delete(key);
      else newQuery.set(key, value);
      setQuery(newQuery);
      window.history.pushState(
        {},
        '',
        newQuery.toString().length === 0
          ? pathname
          : `${pathname}?${newQuery.toString()}`,
      );
    },
    [pathname, search],
  );

  return [query, updateQuery];
};
